var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 col-lg-8 order-lg-1" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.alert !== "",
              expression: "alert !== ''",
            },
          ],
          staticClass: "alert__block",
        },
        [
          _c("div", { staticClass: "alert__block_header" }, [
            _c("h3", { staticClass: "h_text" }, [
              _vm._v(
                _vm._s(_vm.get_translation_constant("text_dear_customer"))
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "alert__block_close",
                on: {
                  click: function ($event) {
                    _vm.alert = ""
                  },
                },
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M7.1 17.34a.73.73 0 000 1.02c.28.27.74.27 1.02 0l4.66-4.66 4.66 4.66c.28.27.75.28 1.02 0a.74.74 0 000-1.02l-4.66-4.67 4.66-4.65a.73.73 0 000-1.03.74.74 0 00-1.02 0l-4.66 4.67-4.66-4.67a.73.73 0 00-1.03 0 .73.73 0 000 1.02l4.67 4.66-4.67 4.67z",
                        fill: "#000",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("pre", [_vm._v(_vm._s(_vm.alert))]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "simple__block" }, [
        _c("h3", { staticClass: "h5" }, [
          _vm._v(_vm._s(_vm.get_translation_constant("text_add_new_order"))),
        ]),
        _vm._v(" "),
        _c("form", { attrs: { action: "" } }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass: "col-12 col-lg-6 track_code form__col",
                class: _vm.hasError("track_code"),
              },
              [
                _c(
                  "label",
                  { staticClass: "d-flex align-items-center gap-1" },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_tracking_number_full"
                          )
                        )
                    ),
                    _c("sup", [_vm._v("*")]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.new_order.track_code,
                      expression: "new_order.track_code",
                    },
                  ],
                  ref: "tracking",
                  staticClass: "form__control",
                  attrs: {
                    id: "tracking_number",
                    name: "tracking_number",
                    type: "text",
                    placeholder: _vm.get_translation_constant(
                      "text_10_to_24_characters"
                    ),
                    minlength: "10",
                    maxlength: "24",
                    disabled:
                      _vm.parcel !== null &&
                      _vm.parcel.parcel_tracking_status_id === 2,
                  },
                  domProps: { value: _vm.new_order.track_code },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.new_order, "track_code", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm.hasErrorMessage("track_code")
                  ? _c("div", { staticClass: "form__error" }, [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.hasErrorMessage("track_code")) +
                          "\n                    "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-lg-6" }, [
              _c(
                "div",
                {
                  staticClass: "form__col",
                  class: _vm.hasError("market_category_id"),
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant("text_product_category")
                      )
                    ),
                    _c("sup", [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    staticClass: "selectpicker",
                    attrs: {
                      multiple: false,
                      placeholder: _vm.get_translation_constant(
                        "text_choose_category"
                      ),
                      options: _vm.filteredCategories,
                      label: "title",
                      selectLabel: "",
                      deselectLabel: "",
                      optionHeight: 48,
                      showPointer: true,
                      disabled:
                        _vm.parcel !== null &&
                        _vm.parcel.parcel_tracking_status_id === 2 &&
                        !!_vm.localParcel.declared,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "singleLabel",
                        fn: function (ref) {
                          var option = ref.option
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "multiselect__single",
                                class:
                                  typeof option.id !== "undefined" &&
                                  option.id === ""
                                    ? "multiselect__placeholder__active"
                                    : "",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    typeof option.id !== "undefined" &&
                                      option.id === ""
                                      ? _vm.get_translation_constant(
                                          "text_choose_category"
                                        )
                                      : option.title
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.new_order.category,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_order, "category", $$v)
                      },
                      expression: "new_order.category",
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasErrorMessage("market_category_id")
                    ? _c("div", { staticClass: "form__error" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_field_is_required"
                              )
                            ) +
                            "\n                        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form__col", class: _vm.hasError("market_id") },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.get_translation_constant("text_shop"))),
                    _c("sup", [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "autocomplete" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search,
                          expression: "search",
                        },
                      ],
                      staticClass: "form__control",
                      attrs: {
                        id: "shop",
                        type: "text",
                        name: "shop",
                        placeholder:
                          _vm.get_translation_constant("text_start_typing"),
                        autocomplete: "off",
                        disabled:
                          _vm.parcel !== null &&
                          _vm.parcel.parcel_tracking_status_id === 2 &&
                          !!_vm.localParcel.declared,
                      },
                      domProps: { value: _vm.search },
                      on: {
                        focus: function ($event) {
                          return _vm.clearShopData()
                        },
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.search = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        class: _vm.getShopResultClass,
                        attrs: { id: "results" },
                      },
                      _vm._l(_vm.filteredShops, function (shop, index) {
                        return _c(
                          "li",
                          {
                            staticClass: "result",
                            on: {
                              click: function ($event) {
                                return _vm.setShop(shop)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "user_serch_name" }),
                            _vm._v(" "),
                            _c(
                              "span",
                              { staticClass: "user_room" },
                              [
                                _vm._l(
                                  shop.title
                                    .toLowerCase()
                                    .split(_vm.search.toLowerCase()),
                                  function (name, index) {
                                    return [
                                      shop.title
                                        .toLowerCase()
                                        .split(_vm.search.toLowerCase())
                                        .length === 1
                                        ? [
                                            _c(
                                              "span",
                                              { staticClass: "highlight" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.search.toLowerCase()
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(_vm._s(name)),
                                          ]
                                        : index !==
                                            shop.title
                                              .toLowerCase()
                                              .split(_vm.search.toLowerCase())
                                              .length -
                                              1 &&
                                          shop.title
                                            .toLowerCase()
                                            .split(_vm.search.toLowerCase())
                                            .length > 1
                                        ? [
                                            _vm._v(_vm._s(name)),
                                            _c(
                                              "span",
                                              { staticClass: "highlight" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.search.toLowerCase()
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        : [_vm._v(_vm._s(name))],
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.hasErrorMessage("market_id")
                      ? _c("div", { staticClass: "form__error" }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(
                                _vm.get_translation_constant(
                                  "text_field_is_required"
                                )
                              ) +
                              "\n                            "
                          ),
                        ])
                      : _vm._e(),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-lg-6" }, [
              _c(
                "div",
                {
                  staticClass: "form__col",
                  class: _vm.hasError("delivery_type"),
                },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(_vm.get_translation_constant("text_delivery_type"))
                    ),
                    _c("sup", [_vm._v("*")]),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    staticClass: "selectpicker",
                    attrs: {
                      multiple: false,
                      placeholder: _vm.get_translation_constant(
                        "text_choose_delivery_type"
                      ),
                      options: _vm.deliveryTypes,
                      label: "title",
                      selectLabel: "",
                      deselectLabel: "",
                      "track-by": "id",
                      optionHeight: 48,
                      showPointer: true,
                      disabled:
                        _vm.parcel !== null &&
                        _vm.parcel.parcel_tracking_status_id === 2 &&
                        !!_vm.localParcel.declared,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "singleLabel",
                        fn: function (ref) {
                          var option = ref.option
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "multiselect__single",
                                class:
                                  typeof option.id !== "undefined" &&
                                  option.id === ""
                                    ? "multiselect__placeholder__active"
                                    : "",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    typeof option.id !== "undefined" &&
                                      option.id === ""
                                      ? _vm.get_translation_constant(
                                          "text_choose_delivery_type"
                                        )
                                      : option.title
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.new_order.delivery_type,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_order, "delivery_type", $$v)
                      },
                      expression: "new_order.delivery_type",
                    },
                  }),
                  _vm._v(" "),
                  _vm.hasErrorMessage("delivery_type")
                    ? _c("div", { staticClass: "form__error" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.get_translation_constant(
                                "text_field_is_required"
                              )
                            ) +
                            "\n                        "
                        ),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product__item_template" }, [
            _c("div", { staticClass: "product__item" }, [
              _c("div", { staticClass: "row small-gutters" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-3 col-lg-3 product__item_col_name",
                  },
                  [
                    _c("div", { staticClass: "form__col" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_product"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.new_order.products[0].name,
                            expression: "new_order.products[0].name",
                          },
                        ],
                        staticClass: "form__control",
                        attrs: {
                          id: "product_name",
                          name: "",
                          type: "text",
                          placeholder:
                            _vm.get_translation_constant("text_product_name"),
                          disabled:
                            _vm.parcel !== null &&
                            _vm.parcel.parcel_tracking_status_id === 2 &&
                            !!_vm.localParcel.declared,
                        },
                        domProps: { value: _vm.new_order.products[0].name },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.enterHandle()
                          },
                          keydown: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            $event.preventDefault()
                            return _vm.enterHandle()
                          },
                          input: function ($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.new_order.products[0],
                              "name",
                              $event.target.value
                            )
                          },
                        },
                      }),
                      _vm._v(" "),
                      _vm.hasErrorMessage("products.0.name")
                        ? _c(
                            "div",
                            {
                              staticClass: "form__error",
                              staticStyle: { display: "block", color: "red" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.hasErrorMessage("products.0.name")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-12 col-md-3 col-lg-3" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form__col",
                      class: _vm.hasError("products.0.category"),
                    },
                    [
                      _c("label", { attrs: { for: "" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_translation_constant("text_categories")
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("multiselect", {
                        staticClass: "selectpicker form__control",
                        attrs: {
                          multiple: false,
                          placeholder: _vm.get_translation_constant(
                            "text_choose_category"
                          ),
                          options: _vm.goodsList,
                          label: "title",
                          selectLabel: "",
                          deselectLabel: "",
                          optionHeight: 48,
                          showPointer: true,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "singleLabel",
                            fn: function (ref) {
                              var option = ref.option
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "multiselect__single",
                                    class:
                                      typeof option.IdRef !== "undefined" &&
                                      option.IdRef === ""
                                        ? "multiselect__placeholder__active"
                                        : "",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        typeof option.IdRef !== "undefined" &&
                                          option.IdRef === ""
                                          ? _vm.get_translation_constant(
                                              "text_choose_category"
                                            )
                                          : option.title
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.new_order.products[0].category,
                          callback: function ($$v) {
                            _vm.$set(_vm.new_order.products[0], "category", $$v)
                          },
                          expression: "new_order.products[0].category",
                        },
                      }),
                      _vm._v(" "),
                      _vm.hasErrorMessage("products.0.category")
                        ? _c("div", { staticClass: "form__error" }, [
                            _vm._v(
                              "\n                                    " +
                                _vm._s(
                                  _vm.get_translation_constant(
                                    "text_field_is_required"
                                  )
                                ) +
                                "\n                                "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-auto col-md-2 col-lg-2 product__item_col_quantity col-custom-1",
                  },
                  [
                    _c("div", { staticClass: "form__col" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_qty"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "block__input_quantity" }, [
                        _c("button", {
                          staticClass: "js-minus",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.decrementExampleQty.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.new_order.products[0].qty,
                              expression: "new_order.products[0].qty",
                            },
                          ],
                          staticClass: "form__control input_quantity",
                          attrs: {
                            id: "product_quantity_",
                            name: "",
                            type: "number",
                            disabled:
                              _vm.parcel !== null &&
                              _vm.parcel.parcel_tracking_status_id === 2 &&
                              !!_vm.localParcel.declared,
                          },
                          domProps: { value: _vm.new_order.products[0].qty },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.new_order.products[0],
                                  "qty",
                                  $event.target.value
                                )
                              },
                              _vm.controlQtyExample,
                            ],
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.enterHandle()
                            },
                            keydown: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              $event.preventDefault()
                              return _vm.enterHandle()
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "js-plus",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.incrementExampleQty.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm.hasErrorMessage("products.0.qty")
                        ? _c(
                            "div",
                            {
                              staticClass: "form__error",
                              staticStyle: { display: "block", color: "red" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.hasErrorMessage("products.0.qty")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-auto col-md-3 col-lg-3 product__item_col_price col-custom-2",
                  },
                  [
                    _c("div", { staticClass: "form__col" }, [
                      _c("label", [
                        _vm._v(
                          _vm._s(_vm.get_translation_constant("text_price"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "product__item_price_block" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.new_order.products[0].price,
                                expression: "new_order.products[0].price",
                              },
                            ],
                            staticClass: "form__control",
                            attrs: {
                              id: "product_price",
                              name: "",
                              type: "text",
                              placeholder:
                                _vm.get_translation_constant(
                                  "text_product_name"
                                ),
                              disabled:
                                _vm.parcel !== null &&
                                _vm.parcel.parcel_tracking_status_id === 2 &&
                                !!_vm.localParcel.declared,
                            },
                            domProps: {
                              value: _vm.new_order.products[0].price,
                            },
                            on: {
                              input: [
                                function ($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.new_order.products[0],
                                    "price",
                                    $event.target.value
                                  )
                                },
                                _vm.controlInputExamplePrice,
                              ],
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.enterHandle()
                              },
                              keydown: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.enterHandle()
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "multiselect",
                            {
                              staticClass: "selectpicker",
                              attrs: {
                                multiple: false,
                                placeholder: "",
                                options: _vm.currencyList,
                                label: "symbol",
                                selectLabel: "",
                                deselectLabel: "",
                                optionHeight: 48,
                                showPointer: true,
                                disabled:
                                  _vm.parcel !== null &&
                                  _vm.parcel.parcel_tracking_status_id === 2 &&
                                  !!_vm.localParcel.declared,
                              },
                              model: {
                                value: _vm.new_order.products[0].currency,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.new_order.products[0],
                                    "currency",
                                    $$v
                                  )
                                },
                                expression: "new_order.products[0].currency",
                              },
                            },
                            [void 0],
                            2
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasErrorMessage("products.0.price")
                        ? _c(
                            "div",
                            {
                              staticClass: "form__error",
                              staticStyle: { display: "block", color: "red" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.hasErrorMessage("products.0.price")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasErrorMessage("products.0.currency")
                        ? _c(
                            "div",
                            {
                              staticClass: "form__error",
                              staticStyle: { display: "block", color: "red" },
                            },
                            [
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(
                                    _vm.hasErrorMessage("products.0.currency")
                                  ) +
                                  "\n                                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-auto col-md-1 col-lg-1 col-custom-3" },
                  [
                    _c("div", { staticClass: "product__item_action" }, [
                      _c(
                        "button",
                        {
                          staticClass: "product__item_add",
                          attrs: {
                            title:
                              _vm.get_translation_constant("text_add_product"),
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.addProduct()
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M12 21.6c5.24 0 9.6-4.35 9.6-9.6 0-5.24-4.37-9.6-9.61-9.6A9.66 9.66 0 002.4 12c0 5.25 4.35 9.6 9.6 9.6zm0-1.6c-4.44 0-8-3.56-8-8a8 8 0 118 8zm-.03-3.53c.51 0 .81-.35.81-.9V12.8h2.95c.52 0 .9-.27.9-.77s-.36-.8-.9-.8h-2.95V8.26c0-.55-.3-.9-.8-.9s-.78.37-.78.9v2.96H8.26c-.55 0-.9.3-.9.8s.38.77.9.77h2.94v2.79c0 .52.27.9.77.9z",
                                  fill: "#00A5FF",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "products_list" },
            [
              _vm._l(_vm.productList, function (product, index) {
                return [
                  !!(_vm.new_order.products.length - index - 1)
                    ? _c("div", { staticClass: "product__item" }, [
                        _c("div", { staticClass: "row small-gutters" }, [
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-3 col-lg-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError(
                                    "products." + (index + 1) + ".name"
                                  ),
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      attrs: { for: "product_name_1" + index },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_product"
                                          )
                                        ) +
                                          "\n                                        " +
                                          _vm._s(
                                            _vm.new_order.products.length -
                                              index
                                          )
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.new_order.products[
                                            _vm.new_order.products.length -
                                              index -
                                              1
                                          ].name,
                                        expression:
                                          "new_order.products[new_order.products.length - index-1].name",
                                      },
                                    ],
                                    staticClass: "form__control",
                                    attrs: {
                                      id: "product_name_1" + index,
                                      name: "product" + index,
                                      type: "text",
                                      placeholder:
                                        _vm.get_translation_constant(
                                          "text_product_name"
                                        ),
                                      disabled:
                                        _vm.parcel !== null &&
                                        _vm.parcel.parcel_tracking_status_id ===
                                          2 &&
                                        !!_vm.localParcel.declared,
                                    },
                                    domProps: {
                                      value:
                                        _vm.new_order.products[
                                          _vm.new_order.products.length -
                                            index -
                                            1
                                        ].name,
                                    },
                                    on: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.enterHandle()
                                      },
                                      keydown: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        $event.preventDefault()
                                        return _vm.enterHandle()
                                      },
                                      input: function ($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.new_order.products[
                                            _vm.new_order.products.length -
                                              index -
                                              1
                                          ],
                                          "name",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.hasErrorMessage(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".name"
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "form__error" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_field_is_required"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "col-12 col-md-3 col-lg-3" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".category"
                                  ),
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.get_translation_constant(
                                          "text_product_category_for_ukraine"
                                        )
                                      )
                                    ),
                                    _c("sup", [_vm._v("*")]),
                                  ]),
                                  _vm._v(" "),
                                  _c("multiselect", {
                                    staticClass: "selectpicker",
                                    attrs: {
                                      multiple: false,
                                      placeholder: _vm.get_translation_constant(
                                        "text_choose_category"
                                      ),
                                      options: _vm.goodsList,
                                      label: "title",
                                      selectLabel: "",
                                      deselectLabel: "",
                                      optionHeight: 48,
                                      showPointer: true,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "singleLabel",
                                          fn: function (ref) {
                                            var option = ref.option
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "multiselect__single",
                                                  class:
                                                    typeof option.IdRef !==
                                                      "undefined" &&
                                                    option.IdRef === ""
                                                      ? "multiselect__placeholder__active"
                                                      : "",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      typeof option.IdRef !==
                                                        "undefined" &&
                                                        option.IdRef === ""
                                                        ? _vm.get_translation_constant(
                                                            "text_choose_category"
                                                          )
                                                        : option.title
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value:
                                        _vm.new_order.products[
                                          _vm.new_order.products.length -
                                            index -
                                            1
                                        ].category,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.new_order.products[
                                            _vm.new_order.products.length -
                                              index -
                                              1
                                          ],
                                          "category",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "new_order.products[new_order.products.length - index-1].category",
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.hasErrorMessage(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".category"
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "form__error" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_field_is_required"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-auto col-md-2 col-lg-2 col-custom-1",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".qty"
                                  ),
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "product_qty_1" + index } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_qty"
                                          )
                                        )
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "block__input_quantity" },
                                    [
                                      _c("button", {
                                        staticClass: "js-minus",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.decrementQty(
                                              _vm.new_order.products.length -
                                                index -
                                                1
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.new_order.products[
                                                _vm.new_order.products.length -
                                                  index -
                                                  1
                                              ].qty,
                                            expression:
                                              "new_order.products[new_order.products.length - index-1].qty",
                                          },
                                        ],
                                        staticClass:
                                          "form__control input_quantity type_tel",
                                        attrs: {
                                          id: "product_qty_1" + index,
                                          name: "product_qty" + index,
                                          type: "number",
                                          disabled:
                                            _vm.parcel !== null &&
                                            _vm.parcel
                                              .parcel_tracking_status_id ===
                                              2 &&
                                            !!_vm.localParcel.declared,
                                        },
                                        domProps: {
                                          value:
                                            _vm.new_order.products[
                                              _vm.new_order.products.length -
                                                index -
                                                1
                                            ].qty,
                                        },
                                        on: {
                                          input: [
                                            function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_order.products[
                                                  _vm.new_order.products
                                                    .length -
                                                    index -
                                                    1
                                                ],
                                                "qty",
                                                $event.target.value
                                              )
                                            },
                                            function ($event) {
                                              return _vm.controlQty(
                                                _vm.new_order.products.length -
                                                  index -
                                                  1
                                              )
                                            },
                                          ],
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.enterHandle()
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.enterHandle()
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("button", {
                                        staticClass: "js-plus",
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.incrementQty(
                                              _vm.new_order.products.length -
                                                index -
                                                1
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.hasErrorMessage(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".qty"
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "form__error" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_field_is_required"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-auto col-md-3 col-lg-3 col-custom-2",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "form__col",
                                  class: _vm.hasError(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".price"
                                  ),
                                },
                                [
                                  _c(
                                    "label",
                                    { attrs: { for: "product_price" + index } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.get_translation_constant(
                                            "text_price"
                                          )
                                        )
                                      ),
                                      _c("sup", [_vm._v("*")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "product__item_price_block",
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.new_order.products[
                                                _vm.new_order.products.length -
                                                  index -
                                                  1
                                              ].price,
                                            expression:
                                              "new_order.products[new_order.products.length - index-1].price",
                                          },
                                        ],
                                        staticClass: "form__control type_tel",
                                        attrs: {
                                          id: "product_price" + index,
                                          name: "product_price" + index,
                                          placeholder: "0",
                                          disabled:
                                            _vm.parcel !== null &&
                                            _vm.parcel
                                              .parcel_tracking_status_id ===
                                              2 &&
                                            !!_vm.localParcel.declared,
                                          type: "text",
                                        },
                                        domProps: {
                                          value:
                                            _vm.new_order.products[
                                              _vm.new_order.products.length -
                                                index -
                                                1
                                            ].price,
                                        },
                                        on: {
                                          input: [
                                            function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.new_order.products[
                                                  _vm.new_order.products
                                                    .length -
                                                    index -
                                                    1
                                                ],
                                                "price",
                                                $event.target.value
                                              )
                                            },
                                            function ($event) {
                                              return _vm.controlInput(
                                                _vm.new_order.products.length -
                                                  index -
                                                  1
                                              )
                                            },
                                          ],
                                          keyup: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.enterHandle()
                                          },
                                          keydown: function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            ) {
                                              return null
                                            }
                                            $event.preventDefault()
                                            return _vm.enterHandle()
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "multiselect",
                                        {
                                          staticClass: "selectpicker",
                                          attrs: {
                                            multiple: false,
                                            placeholder: "",
                                            options: _vm.currencyList,
                                            label: "symbol",
                                            selectLabel: "",
                                            deselectLabel: "",
                                            optionHeight: 48,
                                            showPointer: true,
                                            searchable: false,
                                            disabled:
                                              _vm.parcel !== null &&
                                              _vm.parcel
                                                .parcel_tracking_status_id ===
                                                2 &&
                                              !!_vm.localParcel.declared,
                                          },
                                          model: {
                                            value:
                                              _vm.new_order.products[
                                                _vm.new_order.products.length -
                                                  index -
                                                  1
                                              ].currency,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.new_order.products[
                                                  _vm.new_order.products
                                                    .length -
                                                    index -
                                                    1
                                                ],
                                                "currency",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "new_order.products[new_order.products.length - index-1].currency",
                                          },
                                        },
                                        [void 0],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.hasErrorMessage(
                                    "products." +
                                      (_vm.new_order.products.length -
                                        index -
                                        1) +
                                      ".price"
                                  )
                                    ? _c(
                                        "div",
                                        { staticClass: "form__error" },
                                        [
                                          _vm._v(
                                            "\n                                        " +
                                              _vm._s(
                                                _vm.get_translation_constant(
                                                  "text_field_is_required"
                                                )
                                              ) +
                                              "\n                                    "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-auto col-md-1 col-lg-1 col-custom-3",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "product__item_action" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "product__item_remove",
                                      attrs: {
                                        title: _vm.get_translation_constant(
                                          "text_remove_product"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.removeProduct(product)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M17.2 18.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V5.7c0-1.02-.72-1.69-1.86-1.69h-2.76c-1.14 0-1.84.67-1.84 1.69v1.07H5.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM9.96 5.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM8.73 18.93a.75.75 0 01-.77-.73L7.44 7.84h9.1l-.5 10.36a.74.74 0 01-.76.73H8.73zm5.46-1.26c.25 0 .43-.2.44-.47l.22-7.56c0-.27-.18-.47-.44-.47-.22 0-.42.2-.42.46l-.23 7.57c0 .26.18.47.43.47zm-4.38 0c.26 0 .44-.21.43-.47l-.22-7.57c0-.25-.2-.46-.43-.46-.26 0-.44.2-.43.47l.23 7.56c0 .27.18.47.42.47zm2.64-.47V9.63c0-.25-.2-.46-.44-.46-.25 0-.45.2-.45.46v7.57c0 .26.2.47.45.47.23 0 .44-.21.44-.47z",
                                              fill: "#76777C",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form__col d-flex justify-content-lg-end" },
            [
              _c("div", { staticClass: "packages__total_price" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.get_translation_constant("text_total_products_price")
                    ) +
                    ": "
                ),
                _c("span", [_vm._v(_vm._s(_vm.getFinalPrice.total))]),
                _vm._v(
                  " " + _vm._s(_vm.getFinalPrice.symbol) + "\n                "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "extra__services" }, [
            _c("h4", { staticClass: "h_text_small with__line" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("text_additional_services")
                  ) + " +"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "new-order-main",
                class: {
                  "has-splits": _vm.splits.length && _vm.checkedSplit && false,
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(
                      _vm.sliceIntoChunks(_vm.services, 3),
                      function (chunkServices, index) {
                        return _vm._l(
                          chunkServices,
                          function (service, chunk_index) {
                            return _c(
                              "div",
                              { staticClass: "col-12 col-md-6 col-lg-5" },
                              [
                                _c("div", { staticClass: "checkbox__custom" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.new_order.services[
                                            index * 3 + chunk_index
                                          ].checked,
                                        expression:
                                          "new_order.services[index * 3 + chunk_index].checked",
                                      },
                                    ],
                                    attrs: {
                                      id:
                                        "checkbox" + (index * 3 + chunk_index),
                                      name:
                                        "checkbox" + (index * 3 + chunk_index),
                                      type: "checkbox",
                                      disabled:
                                        _vm.parcel !== null &&
                                        _vm.parcel.parcel_tracking_status_id ===
                                          2 &&
                                        !!_vm.localParcel.declared,
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.new_order.services[
                                          index * 3 + chunk_index
                                        ].checked
                                      )
                                        ? _vm._i(
                                            _vm.new_order.services[
                                              index * 3 + chunk_index
                                            ].checked,
                                            null
                                          ) > -1
                                        : _vm.new_order.services[
                                            index * 3 + chunk_index
                                          ].checked,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.new_order.services[
                                              index * 3 + chunk_index
                                            ].checked,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.new_order.services[
                                                  index * 3 + chunk_index
                                                ],
                                                "checked",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.new_order.services[
                                                  index * 3 + chunk_index
                                                ],
                                                "checked",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.new_order.services[
                                              index * 3 + chunk_index
                                            ],
                                            "checked",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          "checkbox" +
                                          (index * 3 + chunk_index),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tooltip__block tooltip__right tooltip__modal",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip__block_trigger",
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "service-image",
                                                attrs: {
                                                  src: service.icon,
                                                  alt: "",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(service.title) +
                                                  "\n                                        "
                                              ),
                                              !!service.value
                                                ? _c(
                                                    "span",
                                                    [
                                                      _vm._v(
                                                        "+ " +
                                                          _vm._s(
                                                            service.value
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                      service.as_a_percentage
                                                        ? [_vm._v("%")]
                                                        : [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.getCurrencySymbol(
                                                                  service
                                                                )
                                                              )
                                                            ),
                                                          ],
                                                    ],
                                                    2
                                                  )
                                                : _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.get_translation_constant(
                                                          "text_free"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip__block_overlay",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tooltip__block_inner",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "tooltip__block_close",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        service.description
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: service.link,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.get_translation_constant(
                                                              "text_learn_more_about_insurance"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            )
                          }
                        )
                      }
                    ),
                    _vm._v(" "),
                    _vm._l(
                      _vm.sliceIntoChunks(_vm.solutions, 3),
                      function (chunkSolutions, index) {
                        return _vm._l(
                          chunkSolutions,
                          function (solution, chunk_index) {
                            return _c(
                              "div",
                              { staticClass: "col-12 col-md-6 col-lg-5 df" },
                              [
                                _c("div", { staticClass: "checkbox__custom" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.new_order.solutions[
                                            index * 3 + chunk_index
                                          ].checked,
                                        expression:
                                          "new_order.solutions[index * 3 + chunk_index].checked",
                                      },
                                    ],
                                    attrs: {
                                      id:
                                        "checkbox_solution" +
                                        (index * 3 + chunk_index),
                                      name:
                                        "checkbox_solution" +
                                        (index * 3 + chunk_index),
                                      type: "checkbox",
                                      disabled:
                                        solution.solution_id === 1 &&
                                        (!!(_vm.newProductsCnt < 2) ||
                                          _vm.parcel !== null),
                                    },
                                    domProps: {
                                      checked: Array.isArray(
                                        _vm.new_order.solutions[
                                          index * 3 + chunk_index
                                        ].checked
                                      )
                                        ? _vm._i(
                                            _vm.new_order.solutions[
                                              index * 3 + chunk_index
                                            ].checked,
                                            null
                                          ) > -1
                                        : _vm.new_order.solutions[
                                            index * 3 + chunk_index
                                          ].checked,
                                    },
                                    on: {
                                      change: function ($event) {
                                        var $$a =
                                            _vm.new_order.solutions[
                                              index * 3 + chunk_index
                                            ].checked,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = null,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              _vm.$set(
                                                _vm.new_order.solutions[
                                                  index * 3 + chunk_index
                                                ],
                                                "checked",
                                                $$a.concat([$$v])
                                              )
                                          } else {
                                            $$i > -1 &&
                                              _vm.$set(
                                                _vm.new_order.solutions[
                                                  index * 3 + chunk_index
                                                ],
                                                "checked",
                                                $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1))
                                              )
                                          }
                                        } else {
                                          _vm.$set(
                                            _vm.new_order.solutions[
                                              index * 3 + chunk_index
                                            ],
                                            "checked",
                                            $$c
                                          )
                                        }
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      attrs: {
                                        for:
                                          "checkbox_solution" +
                                          (index * 3 + chunk_index),
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "tooltip__block tooltip__right tooltip__modal",
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip__block_trigger",
                                            },
                                            [
                                              _c("img", {
                                                staticClass: "service-image",
                                                attrs: {
                                                  src: solution.icon,
                                                  alt: "",
                                                },
                                              }),
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(solution.title) +
                                                  "\n                                        "
                                              ),
                                              solution.as_percentage
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(solution.value) +
                                                        " %\n                                        "
                                                    ),
                                                  ])
                                                : [
                                                    !!solution.tariff
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "+ " +
                                                              _vm._s(
                                                                solution.tariff
                                                              ) +
                                                              " " +
                                                              _vm._s(
                                                                _vm.getCurrencySymbol(
                                                                  solution
                                                                )
                                                              )
                                                          ),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.get_translation_constant(
                                                                "text_free"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                  ],
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "tooltip__block_overlay",
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "tooltip__block_inner",
                                                },
                                                [
                                                  _c("span", {
                                                    staticClass:
                                                      "tooltip__block_close",
                                                  }),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _vm._v(
                                                      _vm._s(
                                                        solution.description
                                                      )
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("p", [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: {
                                                          href: solution.link,
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            solution.link_info
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                solution.solution_id === 1 &&
                                solution.checked &&
                                _vm.newProductsCnt > 1
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "product__item_col_quantity",
                                        class:
                                          (_vm.services.length + chunk_index) %
                                            2 ===
                                          0
                                            ? "split-even"
                                            : "split-odd",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "form__col",
                                            class: _vm.hasError("split_count"),
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "block__input_quantity",
                                              },
                                              [
                                                _c("span", {
                                                  staticClass: "js-minus",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.decrementSplitQty.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value:
                                                        _vm.new_order
                                                          .split_count,
                                                      expression:
                                                        "new_order.split_count",
                                                    },
                                                  ],
                                                  staticClass:
                                                    "form__control input_quantity",
                                                  attrs: {
                                                    id: "splitCnt",
                                                    name: "",
                                                    type: "number",
                                                    min: 2,
                                                    step: 1,
                                                    max: _vm.newProductsCnt,
                                                    disabled:
                                                      _vm.parcel !== null &&
                                                      _vm.parcel
                                                        .parcel_tracking_status_id ===
                                                        2 &&
                                                      !!_vm.localParcel
                                                        .declared,
                                                  },
                                                  domProps: {
                                                    value:
                                                      _vm.new_order.split_count,
                                                  },
                                                  on: {
                                                    input: [
                                                      function ($event) {
                                                        if (
                                                          $event.target
                                                            .composing
                                                        ) {
                                                          return
                                                        }
                                                        _vm.$set(
                                                          _vm.new_order,
                                                          "split_count",
                                                          $event.target.value
                                                        )
                                                      },
                                                      function ($event) {
                                                        return _vm.controlInputSplit(
                                                          $event.target.value
                                                        )
                                                      },
                                                    ],
                                                    change: function ($event) {
                                                      return _vm.controlInputSplitQty(
                                                        $event.target.value,
                                                        _vm.newProductsCnt
                                                      )
                                                    },
                                                    keyup: function ($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      $event.preventDefault()
                                                      return _vm.enterHandle()
                                                    },
                                                    keydown: function ($event) {
                                                      if (
                                                        !$event.type.indexOf(
                                                          "key"
                                                        ) &&
                                                        _vm._k(
                                                          $event.keyCode,
                                                          "enter",
                                                          13,
                                                          $event.key,
                                                          "Enter"
                                                        )
                                                      ) {
                                                        return null
                                                      }
                                                      $event.preventDefault()
                                                      return _vm.enterHandle()
                                                    },
                                                    focus: function ($event) {
                                                      _vm.new_order.split_count =
                                                        ""
                                                    },
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("span", {
                                                  staticClass: "js-plus",
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.incrementSplitQty.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.hasErrorMessage("split_count")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass: "form__error",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                            " +
                                                        _vm._s(
                                                          _vm.hasErrorMessage(
                                                            "split_count"
                                                          )
                                                        ) +
                                                        "\n                                        "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            )
                          }
                        )
                      }
                    ),
                  ],
                  2
                ),
              ]
            ),
            _vm._v(" "),
            _vm.splits.length && _vm.checkedSplit && false
              ? _c(
                  "div",
                  { staticClass: "row splits" },
                  [
                    _vm._l(_vm.splits, function (split, splitIndex) {
                      return [
                        _c("div", { staticClass: "new-order-split-item" }, [
                          _c(
                            "div",
                            { staticClass: "new-order-split-item-code" },
                            [
                              _c(
                                "a",
                                { attrs: { onclick: "void(0)", href: "" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.new_order.track_code +
                                        "-" +
                                        (splitIndex + 1)
                                    )
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm._l(
                                _vm.sliceIntoChunks(_vm.splitServices, 3),
                                function (chunkSplitServices, index) {
                                  return _vm._l(
                                    chunkSplitServices,
                                    function (splitService, chunk_split_index) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-md-6 col-lg-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checkbox__custom" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.splits[splitIndex][
                                                        "services"
                                                      ][
                                                        index * 3 +
                                                          chunk_split_index
                                                      ].checked,
                                                    expression:
                                                      "splits[splitIndex]['services'][index * 3 + chunk_split_index].checked",
                                                  },
                                                ],
                                                attrs: {
                                                  id:
                                                    "split-service-checkbox" +
                                                    splitIndex +
                                                    index * 3 +
                                                    chunk_split_index,
                                                  name:
                                                    "split-service-checkbox" +
                                                    splitIndex +
                                                    index * 3 +
                                                    chunk_split_index,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.splits[splitIndex][
                                                      "services"
                                                    ][
                                                      index * 3 +
                                                        chunk_split_index
                                                    ].checked
                                                  )
                                                    ? _vm._i(
                                                        _vm.splits[splitIndex][
                                                          "services"
                                                        ][
                                                          index * 3 +
                                                            chunk_split_index
                                                        ].checked,
                                                        null
                                                      ) > -1
                                                    : _vm.splits[splitIndex][
                                                        "services"
                                                      ][
                                                        index * 3 +
                                                          chunk_split_index
                                                      ].checked,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.splits[splitIndex][
                                                          "services"
                                                        ][
                                                          index * 3 +
                                                            chunk_split_index
                                                        ].checked,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.splits[
                                                              splitIndex
                                                            ]["services"][
                                                              index * 3 +
                                                                chunk_split_index
                                                            ],
                                                            "checked",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.splits[
                                                              splitIndex
                                                            ]["services"][
                                                              index * 3 +
                                                                chunk_split_index
                                                            ],
                                                            "checked",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.splits[splitIndex][
                                                          "services"
                                                        ][
                                                          index * 3 +
                                                            chunk_split_index
                                                        ],
                                                        "checked",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "split-service-checkbox" +
                                                      splitIndex +
                                                      index * 3 +
                                                      chunk_split_index,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tooltip__block tooltip__right tooltip__modal",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tooltip__block_trigger",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "service-image",
                                                            attrs: {
                                                              src: splitService.icon,
                                                              alt: "",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                                        " +
                                                              _vm._s(
                                                                splitService.title
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                          !!splitService.value
                                                            ? _c(
                                                                "span",
                                                                [
                                                                  _vm._v(
                                                                    "+ " +
                                                                      _vm._s(
                                                                        splitService.value
                                                                      ) +
                                                                      "\n                                                    "
                                                                  ),
                                                                  splitService.as_a_percentage
                                                                    ? [
                                                                        _vm._v(
                                                                          "%"
                                                                        ),
                                                                      ]
                                                                    : [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            _vm.getCurrencySymbol(
                                                                              splitService
                                                                            )
                                                                          )
                                                                        ),
                                                                      ],
                                                                ],
                                                                2
                                                              )
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.get_translation_constant(
                                                                      "text_free"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tooltip__block_overlay",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "tooltip__block_inner",
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "tooltip__block_close",
                                                              }),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    splitService.description
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href: splitService.link,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.get_translation_constant(
                                                                          "text_learn_more_about_insurance"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                }
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.sliceIntoChunks(_vm.splitSolutions, 3),
                                function (chunkSplitSolutions, index) {
                                  return _vm._l(
                                    chunkSplitSolutions,
                                    function (splitSolution, chunk_index) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-12 col-md-6 col-lg-5",
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "checkbox__custom" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value:
                                                      _vm.splits[splitIndex][
                                                        "solutions"
                                                      ][index * 3 + chunk_index]
                                                        .checked,
                                                    expression:
                                                      "splits[splitIndex]['solutions'][index * 3 + chunk_index].checked",
                                                  },
                                                ],
                                                attrs: {
                                                  id:
                                                    "splits-checkbox_solution" +
                                                    splitIndex +
                                                    index * 3 +
                                                    chunk_index,
                                                  name:
                                                    "splits-checkbox_solution" +
                                                    splitIndex +
                                                    index * 3 +
                                                    chunk_index,
                                                  type: "checkbox",
                                                },
                                                domProps: {
                                                  checked: Array.isArray(
                                                    _vm.splits[splitIndex][
                                                      "solutions"
                                                    ][index * 3 + chunk_index]
                                                      .checked
                                                  )
                                                    ? _vm._i(
                                                        _vm.splits[splitIndex][
                                                          "solutions"
                                                        ][
                                                          index * 3 +
                                                            chunk_index
                                                        ].checked,
                                                        null
                                                      ) > -1
                                                    : _vm.splits[splitIndex][
                                                        "solutions"
                                                      ][index * 3 + chunk_index]
                                                        .checked,
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    var $$a =
                                                        _vm.splits[splitIndex][
                                                          "solutions"
                                                        ][
                                                          index * 3 +
                                                            chunk_index
                                                        ].checked,
                                                      $$el = $event.target,
                                                      $$c = $$el.checked
                                                        ? true
                                                        : false
                                                    if (Array.isArray($$a)) {
                                                      var $$v = null,
                                                        $$i = _vm._i($$a, $$v)
                                                      if ($$el.checked) {
                                                        $$i < 0 &&
                                                          _vm.$set(
                                                            _vm.splits[
                                                              splitIndex
                                                            ]["solutions"][
                                                              index * 3 +
                                                                chunk_index
                                                            ],
                                                            "checked",
                                                            $$a.concat([$$v])
                                                          )
                                                      } else {
                                                        $$i > -1 &&
                                                          _vm.$set(
                                                            _vm.splits[
                                                              splitIndex
                                                            ]["solutions"][
                                                              index * 3 +
                                                                chunk_index
                                                            ],
                                                            "checked",
                                                            $$a
                                                              .slice(0, $$i)
                                                              .concat(
                                                                $$a.slice(
                                                                  $$i + 1
                                                                )
                                                              )
                                                          )
                                                      }
                                                    } else {
                                                      _vm.$set(
                                                        _vm.splits[splitIndex][
                                                          "solutions"
                                                        ][
                                                          index * 3 +
                                                            chunk_index
                                                        ],
                                                        "checked",
                                                        $$c
                                                      )
                                                    }
                                                  },
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "label",
                                                {
                                                  attrs: {
                                                    for:
                                                      "splits-checkbox_solution" +
                                                      splitIndex +
                                                      index * 3 +
                                                      chunk_index,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "tooltip__block tooltip__right tooltip__modal",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tooltip__block_trigger",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticClass:
                                                              "service-image",
                                                            attrs: {
                                                              src: splitSolution.icon,
                                                              alt: "",
                                                            },
                                                          }),
                                                          _vm._v(
                                                            "\n                                         " +
                                                              _vm._s(
                                                                splitSolution.title
                                                              ) +
                                                              "\n                                        "
                                                          ),
                                                          splitSolution.as_percentage
                                                            ? [
                                                                _vm._v(
                                                                  "\n                                            " +
                                                                    _vm._s(
                                                                      splitSolution.value
                                                                    ) +
                                                                    " %\n                                        "
                                                                ),
                                                              ]
                                                            : [
                                                                !!splitSolution.tariff
                                                                  ? _c("span", [
                                                                      _vm._v(
                                                                        "+ " +
                                                                          _vm._s(
                                                                            splitSolution.tariff
                                                                          ) +
                                                                          " " +
                                                                          _vm._s(
                                                                            _vm.getCurrencySymbol(
                                                                              splitSolution
                                                                            )
                                                                          )
                                                                      ),
                                                                    ])
                                                                  : _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.get_translation_constant(
                                                                            "text_free"
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]),
                                                              ],
                                                        ],
                                                        2
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "tooltip__block_overlay",
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "tooltip__block_inner",
                                                            },
                                                            [
                                                              _c("span", {
                                                                staticClass:
                                                                  "tooltip__block_close",
                                                              }),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    splitSolution.description
                                                                  )
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c("p", [
                                                                _c(
                                                                  "a",
                                                                  {
                                                                    attrs: {
                                                                      href: splitSolution.link,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        splitSolution.link_info
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  )
                                }
                              ),
                            ],
                            2
                          ),
                        ]),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "files-block" }, [
            _c("h4", { staticClass: "h_text_small with__line" }, [
              _c("span", [
                _vm._v(
                  _vm._s(
                    _vm.get_translation_constant("text_file_block_title")
                  ) + " +"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "files-block__list" },
              [
                _vm._l(_vm.new_order.files, function (f, i) {
                  return _c(
                    "div",
                    {
                      key: f.id || f.name + i,
                      staticClass: "files-block__row",
                    },
                    [
                      _c("div", { staticClass: "files-block__type" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              (f.ext || (f.name || "").split(".").pop() || "")
                                .toUpperCase()
                                .slice(0, 4)
                            ) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "files-block__name",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(f.name) +
                              "\n                        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "files-block__size" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(f.size_label || f.size) +
                            "\n                        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "files-block__delete",
                          attrs: {
                            type: "button",
                            "aria-label": "Delete file",
                            title: "Delete",
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.new_order.files.splice(i, 1)
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 20 20",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73z",
                                  fill: "#515154",
                                },
                              }),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("div", { staticClass: "files-block__actions" }, [
                  _c(
                    "button",
                    {
                      staticClass: "files-block__btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.$refs.filesInput.click()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(
                            _vm.get_translation_constant("text_add_files")
                          ) +
                          "\n                        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "filesInput",
                    staticClass: "files-block__input",
                    attrs: { type: "file", multiple: "" },
                    on: { change: _vm.onFilesPicked },
                  }),
                ]),
              ],
              2
            ),
            _vm._v(" "),
            _c("h4", { staticClass: "h_text_small with__line" }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form__col" }, [
            _c("label", { attrs: { for: "comments" } }, [
              _vm._v(_vm._s(_vm.get_translation_constant("text_comment"))),
            ]),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.new_order.comment,
                  expression: "new_order.comment",
                },
              ],
              staticClass: "form__control",
              attrs: {
                name: "comments",
                id: "comments",
                placeholder: _vm.get_translation_constant("text_comment"),
              },
              domProps: { value: _vm.new_order.comment },
              on: {
                input: function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.new_order, "comment", $event.target.value)
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "row align-items-end" }, [
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c(
                "div",
                { staticClass: "form__col mb-md-0" },
                [
                  _c("label", [
                    _vm._v(
                      _vm._s(
                        _vm.get_translation_constant(
                          "text_delivery_through_agent"
                        )
                      )
                    ),
                    _c(
                      "span",
                      {
                        staticClass:
                          "tooltip__block tooltip__bottom tooltip__modal",
                      },
                      [
                        _c("span", { staticClass: "tooltip__block_trigger" }, [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "14",
                                height: "14",
                                viewBox: "0 0 14 14",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M7 14c3.82 0 7-3.17 7-7 0-3.82-3.18-7-7-7-3.84 0-7 3.18-7 7 0 3.83 3.17 7 7 7zm0-1.17A5.8 5.8 0 011.17 7 5.83 5.83 0 117 12.83zm-.06-8.27c.5 0 .89-.4.89-.9s-.4-.9-.9-.9-.88.4-.88.9.39.9.89.9zm-1.15 6.21h2.8c.28 0 .5-.2.5-.48a.49.49 0 00-.5-.48h-.85V6.32c0-.37-.2-.62-.53-.62H5.9c-.28 0-.5.22-.5.48 0 .28.22.48.5.48h.74v3.15h-.86c-.27 0-.5.22-.5.48 0 .29.23.48.5.48z",
                                  fill: "#515154",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "tooltip__block_overlay" }, [
                          _c("span", { staticClass: "tooltip__block_inner" }, [
                            _c("span", { staticClass: "tooltip__block_close" }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.get_translation_constant("agent_info")
                                )
                              ),
                            ]),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("multiselect", {
                    staticClass: "selectpicker",
                    attrs: {
                      multiple: false,
                      placeholder: _vm.get_translation_constant(
                        "text_delivery_through_agent"
                      ),
                      options: _vm.agentList,
                      label: "name",
                      selectLabel: "",
                      deselectLabel: "",
                      optionHeight: 48,
                      showPointer: true,
                      searchable: false,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "singleLabel",
                        fn: function (ref) {
                          var option = ref.option
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "multiselect__single",
                                class:
                                  typeof option.id !== "undefined" &&
                                  option.id === ""
                                    ? "multiselect__placeholder__active"
                                    : "",
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    typeof option.id !== "undefined" &&
                                      option.id === ""
                                      ? _vm.get_translation_constant(
                                          "text_delivery_through_agent"
                                        )
                                      : option.name
                                  )
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.new_order.agent,
                      callback: function ($$v) {
                        _vm.$set(_vm.new_order, "agent", $$v)
                      },
                      expression: "new_order.agent",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-12 col-md-6" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn__medium btn__block btn__blue",
                  attrs: { disabled: _vm.sendRequestFlag },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.saveOrder()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(_vm.get_translation_constant("text_declaration"))
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.orders_list.length > 0,
              expression: "orders_list.length >0",
            },
          ],
          staticClass: "simple__block",
        },
        [
          _c("h3", { staticClass: "h5" }, [
            _vm._v(_vm._s(_vm.get_translation_constant("text_new_order_list"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table__scroll" }, [
            _c(
              "table",
              {
                staticClass: "table table__new__orders",
                staticStyle: { "table-layout": "auto" },
              },
              [
                _c("thead", [
                  _c("tr", [
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_tracking_number")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_agent"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant(
                            "text_additional_services"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_price"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(
                          _vm.get_translation_constant("text_delivery_type")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.get_translation_constant("text_file"))),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(
                        _vm._s(_vm.get_translation_constant("text_comment"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("th", [
                      _vm._v(_vm._s(_vm.get_translation_constant("text_date"))),
                    ]),
                    _vm._v(" "),
                    _c("th"),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.orders_list, function (order, index) {
                    return _c("tr", [
                      _c("td", [
                        _c("a", { attrs: { href: order.view_link } }, [
                          _vm._v(_vm._s(order.track_code)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(order.agent_name ? order.agent_name : "-")
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        order.services.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "table__extras d-flex flex-nowrap align-items-center gap-2",
                              },
                              _vm._l(
                                order.services,
                                function (service, service_index) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tooltip__block tooltip__top tooltip__block_simple",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tooltip__block_trigger",
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "service-image",
                                            attrs: {
                                              src: service.icon,
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip__block_inner" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "text-nowrap" },
                                            [_vm._v(_vm._s(service.title))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        order.solutions.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "table__extras d-flex flex-nowrap align-items-center gap-2",
                              },
                              _vm._l(
                                order.solutions,
                                function (solution, solution_index) {
                                  return _c(
                                    "span",
                                    {
                                      staticClass:
                                        "tooltip__block tooltip__top tooltip__block_simple",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass: "tooltip__block_trigger",
                                        },
                                        [
                                          _c("img", {
                                            staticClass: "service-image",
                                            attrs: {
                                              src: solution.icon,
                                              alt: "",
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "tooltip__block_inner" },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "text-nowrap" },
                                            [_vm._v(_vm._s(solution.title))]
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        order.services.length === 0 &&
                        order.solutions.length === 0
                          ? _c("span", [_vm._v("-")])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c("strong", { staticClass: "text-nowrap" }, [
                          _vm._v(
                            _vm._s(
                              typeof order.price !== "undefined" &&
                                order.price !== null &&
                                order.price > 0
                                ? order.price + " $"
                                : "-"
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(
                            order.delivery_type_name
                              ? order.delivery_type_name
                              : "-"
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        order.file
                          ? _c("i", { staticClass: "fa-regular fa-file-lines" })
                          : _c("span", [_vm._v("-")]),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        order.comment
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "tooltip__block tooltip__top tooltip__block_simple",
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "fa-solid fa-circle-info tooltip__block_trigger",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "tooltip__block_inner" },
                                  [_c("p", [_vm._v(_vm._s(order.comment))])]
                                ),
                              ]
                            )
                          : _c("span", [_vm._v("-")]),
                      ]),
                      _vm._v(" "),
                      _c("td", { staticStyle: { "white-space": "nowrap" } }, [
                        _vm._v(_vm._s(order.declaration_date)),
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "table__actions d-flex justify-content-end",
                          },
                          [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: order.edit_link,
                                  title:
                                    _vm.get_translation_constant(
                                      "text_edit_product"
                                    ),
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "20",
                                      height: "20",
                                      viewBox: "0 0 20 20",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M17.25 3.87l.55-.59c.27-.27.27-.66 0-.92l-.17-.2c-.23-.24-.6-.2-.85.05l-.56.57 1.03 1.1zm-8.72 8.24l1.48-.68 6.7-6.98-1.05-1.07-6.69 6.99-.68 1.48c-.06.14.1.32.24.26zM5.38 18h8.9c1.37 0 2.16-.82 2.16-2.46V6.73L15.2 8.01v7.47c0 .83-.42 1.24-.94 1.24H5.4c-.75 0-1.18-.41-1.18-1.24V6.5c0-.82.43-1.25 1.18-1.25h6.56l1.22-1.27h-7.8C3.8 3.97 3 4.79 3 6.42v9.12C3 17.18 3.8 18 5.38 18z",
                                        fill: "#06C",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: "#",
                                  title: _vm.get_translation_constant(
                                    "text_remove_product"
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.removeOrder(order)
                                  },
                                },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    attrs: {
                                      width: "20",
                                      height: "20",
                                      viewBox: "0 0 20 20",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg",
                                    },
                                  },
                                  [
                                    _c("path", {
                                      attrs: {
                                        d: "M15.2 16.31l.52-10.47h.73c.3 0 .55-.24.55-.53 0-.3-.24-.55-.55-.55h-3.22V3.7c0-1.02-.72-1.69-1.86-1.69H8.61c-1.14 0-1.84.67-1.84 1.69v1.07H3.55c-.3 0-.55.25-.55.55 0 .3.26.53.55.53h.74l.51 10.48c.05 1.03.75 1.68 1.82 1.68h6.77c1.06 0 1.76-.66 1.82-1.69zM7.96 3.76c0-.4.3-.7.75-.7h2.6c.44 0 .75.3.75.7v1h-4.1v-1zM6.73 16.93a.75.75 0 01-.77-.73L5.44 5.84h9.1l-.5 10.36a.74.74 0 01-.76.73H6.73z",
                                        fill: "#515154",
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ])
                  }),
                  0
                ),
              ]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("alert-modal", {
        attrs: {
          modalId: _vm.modalId,
          title: _vm.modalTitle,
          type: _vm.modalType,
          message: _vm.modalMessage,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      { staticClass: "tooltip__block tooltip__bottom tooltip__modal ms-1" },
      [
        _c("span", { staticClass: "tooltip__block_trigger info-circle" }, [
          _vm._v("?"),
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "tooltip__block_overlay" }, [
          _c("span", { staticClass: "tooltip__block_inner" }, [
            _c("span", { staticClass: "tooltip__block_close" }),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("USPS:")]),
              _vm._v(" 9400136106193335565608, 9261290198173328580118"),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("UPS:")]),
              _vm._v(" 1ZF6Y8414299629992, 1ZRG55030316343163"),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("FedEx:")]),
              _vm._v(" 464241606068, 289551913396"),
            ]),
            _vm._v(" "),
            _c("p", [
              _c("strong", [_vm._v("Amazon:")]),
              _vm._v(" TBA322013076557, TBA321977061419"),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }